import axios from 'axios';
import {apiList} from './apiList';
import { store } from '../config/store';
import { getCompanyBaseURL, getCompanyToken, getCurrentCompanyInfo } from '../utils/companySession';

const axiosInstance2 = axios.create({
  baseURL: apiList.baseUrl909,
  timeout: 100000,
});

axiosInstance2.interceptors.request.use(config => {
  const { userInfo } = store.getState();
  const companyInfo = getCurrentCompanyInfo(userInfo);
  const validCompanyToken = getCompanyToken(companyInfo);
  const baseURL = getCompanyBaseURL(companyInfo) || apiList.baseUrl909;

  if(!userInfo?.userDetails || !validCompanyToken){
      window.location.href = "/login";
  }

  config.baseURL = baseURL;

  if (validCompanyToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${validCompanyToken}`;
  }
  return config;
});

axiosInstance2.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance2;
